import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Lookup  {
    _originalTypeClassName = "zERP.BO.Lookup";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Lookup.translate = translateService;
}
this.Id = null;
this.Id_ = null;
this.Value = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Id_:any;
Value:any;

static getEnumValues(enum_name: any): any{let lst_lookup = [];
let lu = new Domain.Lookup();
switch ((enum_name)) {case "EmploymentType":
{
lu = new Domain.Lookup();lu.Id_ = 0;lu.Value = "Πλήρης απασχόληση";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 1;lu.Value = "Μερικής απασχόλησης";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 2;lu.Value = "Διαλείπουσα";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 3;lu.Value = "Με εκ περιτροπής";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 4;lu.Value = "Διευθυντής";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 5;lu.Value = "Πρακτική";lst_lookup?.add(lu);break;}
case "EmploymentRelationshipType":
{
lu = new Domain.Lookup();lu.Id_ = 0;lu.Value = "Μισθωτός";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 1;lu.Value = "Ημερομίσθιος";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 2;lu.Value = "Ωρομίσθιο";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 3;lu.Value = "Αυτοαπασχολούμενος";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 4;lu.Value = "Απόδειξη Δαπάνης";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 5;lu.Value = "Διοικηση";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 6;lu.Value = "Πρακτική";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 7;lu.Value = "Ασκούμενος";lst_lookup?.add(lu);break;}
case "EmploymentKind":
{
lu = new Domain.Lookup();lu.Id_ = 0;lu.Value = "Μόνιμος";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 1;lu.Value = "Ορισμένου χρόνου";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 2;lu.Value = "Κατά Έργο";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 3;lu.Value = "Υπερσυμβόλαιο";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 4;lu.Value = "Πρακτική Άσκηση & Αμισθί Εργαζόμενοι";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 5;lu.Value = "Ασκούμενος";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 6;lu.Value = "ΙΔΑΧ";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 7;lu.Value = "ΙΔΟΧ";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 8;lu.Value = "Εγκατεστημένο";lst_lookup?.add(lu);break;}
case "EmploymentProperty":
{
lu = new Domain.Lookup();lu.Id_ = 0;lu.Value = "Εργάτης";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 1;lu.Value = "Υπάλληλος";lst_lookup?.add(lu);break;}
case "EmployementSpecialCase":
{
lu = new Domain.Lookup();lu.Id_ = 0;lu.Value = "Πρακτική Άσκηση";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 1;lu.Value = "Ιδ. δικαίου - στενό δημόσιο";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 2;lu.Value = "Ιδ. δικαίου - ευρύτερο δημόσιο";lst_lookup?.add(lu);break;}
case "EmploymentResponsiblePosition":
{
lu = new Domain.Lookup();lu.Id_ = 0;lu.Value = "ΟΧΙ";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 1;lu.Value = "ΘΕΣΗ ΜΕ ΔΙΕΥΘΥΝΤΙΚΟ ΔΙΚΑΙΩΜΑ";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 2;lu.Value = "ΘΕΣΗ ΜΕ ΑΠΟΔΟΧΕΣ ΤΟΥΛΑΧΙΣΤΟΝ ΤΟΥ ΕΞΑΠΛΑΣΙΟΥ ΤΟΥ ΕΛΑΧΙΣΤΟΥ ΝΟΜΟΘΕΤΗΜΕΝΟΥ ΜΙΣΘΟΥ";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 3;lu.Value = "ΘΕΣΗ ΜΕ ΑΠΟΔΟΧΕΣ ΤΟΥΛΑΧΙΣΤΟΝ ΤΟΥ ΟΚΤΑΠΛΑΣΙΟΥ ΤΟΥ ΕΛΑΧΙΣΤΟΥ ΝΟΜΟΘΕΤΗΜΕΝΟΥ ΜΙΣΘΟΥ";lst_lookup?.add(lu);break;}
case "FamilyStatus":
{
lu = new Domain.Lookup();lu.Id_ = 0;lu.Value = "Ανύπαντρος";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 1;lu.Value = "Παντρεμένος";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 2;lu.Value = "Διαζευγμένος";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 3;lu.Value = "Χήρος";lst_lookup?.add(lu);break;}
case "Gender":
{
lu = new Domain.Lookup();lu.Id_ = 0;lu.Value = "Άνδρας";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 1;lu.Value = "Γυναίκα";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 2;lu.Value = "Άλλο";lst_lookup?.add(lu);break;}
case "DocumentType":
{
lu = new Domain.Lookup();lu.Id_ = 0;lu.Value = "Αστυνομική Ταυτότητα";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 1;lu.Value = "Διαβατήριο";lst_lookup?.add(lu);break;}
case "MilitaryObligations":
{
lu = new Domain.Lookup();lu.Id_ = 0;lu.Value = "Ναι";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 1;lu.Value = "Όχι";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 2;lu.Value = "Δεν απαιτείται";lst_lookup?.add(lu);break;}
case "BusinessEntityStatus":
{
lu = new Domain.Lookup();lu.Id_ = 0;lu.Value = "Ενεργή";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 1;lu.Value = "Υπο εκκαθάριση";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 2;lu.Value = "Ανενεργή";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 3;lu.Value = "Κενό";lst_lookup?.add(lu);break;}
case "BusinessEntityKind":
{
lu = new Domain.Lookup();lu.Id_ = 0;lu.Value = "Εταιρία";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 1;lu.Value = "Όμιλος";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 2;lu.Value = "Υποκατάστημα";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 3;lu.Value = "Κενό";lst_lookup?.add(lu);break;}
case "AccountingBookType":
{
lu = new Domain.Lookup();lu.Id_ = 0;lu.Value = "Τύπου 1";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 1;lu.Value = "Τύπου 2";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 2;lu.Value = "Τύπου 3";lst_lookup?.add(lu);lu = new Domain.Lookup();lu.Id_ = 3;lu.Value = "Κενό";lst_lookup?.add(lu);break;}
}
return lst_lookup;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}